module.exports = __webpack_public_path__ + "img/红宝丽.bc19a8ba.png";